import React, { useState } from 'react';
import { View } from 'react-native';
import Text from '../text/Text';
import { Button } from '../button/Button';
import Dialog from './Dialog';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const WarningDialog = ({
	title = 'Warning',
	texts = [],
	subtext,
	isOpen,
	setIsOpen,
	leftButtonText = 'Yes',
	hideLeftButton = false,
	rightButtonText = 'Cancel',
	hideButtons,
	onClick,
	children,
	enableCloseDialog = true,
	isButtonDisabled,
}) => {
	const [isProcessing, setIsProcessing] = useState(false);
	const themedStyles = useThemedStyles(createThemedStyles);

	const displayedText = texts.map((text, i) => {
		return (
			<Text key={`warning_${i}`} style={{ marginTop: 10, marginBotton: 10 }}>
				{text}
			</Text>
		);
	});

	const resolvedIsButtonDisabled = isButtonDisabled || isProcessing;

	return (
		<Dialog
			isOpen={isOpen}
			onClose={() => setIsOpen(false)}
			enableCloseDialog={enableCloseDialog}
			shouldShowCloseIcon={enableCloseDialog}
			closeStyle={{ top: 10, right: 10 }}
		>
			<View>
				<Text style={themedStyles.title}>{title}</Text>
				<View>
					{displayedText}
					{ subtext && (<Text style={themedStyles.subtext}>{subtext}</Text>) }
				</View>
				<View>{ children }</View>
				<View style={[themedStyles.buttonWrapper, hideLeftButton ? { justifyContent: 'flex-end' } : { justifyContent: 'space-between' }]}>
					{
						!hideButtons && (
							<>
								{
									hideLeftButton ? null : (
										<Button
											style={themedStyles.button}
											label={leftButtonText}
											secondary={true}
											onPress={async () => {
												setIsProcessing(true);
												await onClick();
												setIsOpen(false);
												setIsProcessing(false);
											}}
											disabled={resolvedIsButtonDisabled}
											loading={isProcessing}
										/>
									)
								}
								<Button
									style={themedStyles.button}
									label={rightButtonText}
									onPress={() => setIsOpen(false)}
								/>
							</>
						)
					}
				</View>
			</View>
		</Dialog>
	);
};

const createThemedStyles = ({ ui: { colors, type } }) => ({
	title: {
		...type.cardTitle,
		color: colors.text,
		paddingRight: 36,
	},
	text: {
		marginTop: 10,
		color: colors.text,
	},
	subtext: {
		...type.secondary,
		marginTop: 10,
		marginBottom: 10,
		color: colors.textSecondary,
	},
	buttonWrapper: {
		display: 'flex',
		flexDirection: 'row',
		marginTop: 16,
	},
	button: {
		width: '48%',
	},
});

export default WarningDialog;
